import React, { lazy, Suspense } from 'react';
import { ToastContainer } from 'react-toastify'; // Importar el contenedor de Toast
import 'react-toastify/dist/ReactToastify.css'; // Importar los estilos necesarios
import AppRoutes from './routes/AppRoutes';

const App = () => {
    return (
        <>
            <ToastContainer
                position="top-center" // Mover el toast a la parte inferior centrada
                autoClose={3000} // Tiempo en milisegundos antes de cerrarse automáticamente
                hideProgressBar={false} // Mostrar barra de progreso
                newestOnTop // Mostrar el toast más reciente en la parte superior
                closeOnClick // Permitir cerrar al hacer clic
                pauseOnFocusLoss // Pausar al perder el foco
                draggable // Hacer que el toast sea arrastrable
                pauseOnHover // Pausar al pasar el mouse
                theme="light" // Configuración de tema (light o dark)
            />


            <Suspense fallback={<div>Loading...</div>}>
                <AppRoutes />
            </Suspense>
        </>
    );
};

export default App;
